// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import {addDays}  from 'material-ui/DatePicker/dateUtils'
import moment from 'moment';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import TimeField from 'react-simple-timefield';
import TimePicker from 'react-times';

class AddRental extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      customer_search_list: [],
      rent_details: {
        customer_id: '',
        cust_name: '',
        mobile_no: '',
        cust_mobile_no: '',
        name: '',
        venue: '',
        court:'',
        source:'',
        starting_date: '',
        ending_date: '',
        starting_time: '',
        ending_time: '',
        amount: 0,
        game_type: '',
        reason: '',
      },
      failed_list:[],
      completed_list:[],
      game_list:[],
      court_list:[],
      venue_list: [],
      checkedBoxes:[],
      available_court_list:[],
      blocked_court_list: [],
      dayscheckedBoxes:[],
      previous_bulk_booking:'',
      blocked_for_bulk:'',
      available_for_bulk:'',
      isChecked: false,
      data_uploaded: false,
      data_error: false,
      search: false,
      dialog_open: false,
      dialog_open_court_list:false,
      dialog_open_failed_list:false,
      loading: false,
      block_state:true,
      // days: ["Monday","Tuesday","Wednesday","Thrusday","Friday","Saturday","Sunday"]
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    this.searchCustomer = this.searchCustomer.bind(this);
    this.handleStartDate = this.handleStartDate.bind(this);
    this.handleEndDate = this.handleEndDate.bind(this);
    this.handleCustomerSubmit = this.handleCustomerSubmit.bind(this);
    this.handleVenueChange = this.handleVenueChange.bind(this);
    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handleDaysCheckbox = this.handleDaysCheckbox.bind(this);
    this.onStartTimeChange = this.onStartTimeChange.bind(this);
    this.onEndTimeChange = this.onEndTimeChange.bind(this);
    this.handleTopButton = this.handleTopButton.bind(this);
    this.handleGameChange = this.handleGameChange.bind(this);
  }

  componentDidMount() {
    console.log('componentDidMount')
    // this.getCourtList();
    this.getVenueList();
  }

  onEndTimeChange = time => {
    var new_selected_one =  Object.assign({}, this.state.rent_details);
    new_selected_one['ending_time'] = time
    this.setState({rent_details:new_selected_one })
  }

  onStartTimeChange = time => 
    {
      var new_selected_one =  Object.assign({}, this.state.rent_details);
      new_selected_one['starting_time'] = time
      this.setState({rent_details:new_selected_one })
    }

  handleStartDate(date){
    var new_selected_one =  Object.assign({}, this.state.rent_details);
    new_selected_one['starting_date'] = date
    this.setState({rent_details:new_selected_one })
  }

  handleEndDate(date){
    var new_selected_one =  Object.assign({}, this.state.rent_details);
    new_selected_one['ending_date'] = date
    this.setState({rent_details:new_selected_one })
  }

  getVenueList(){
    
    
    const url = `${getLocationOrigin()}/get_venue_list/get_venues_for_buddy/`;
     const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => {this.setState({ venue_list: data.result, game_list: data.result[0].games}), this.getCourtList(data.result[0].id,data.result[0].games[0].game_id)})
       .catch(error => error);
  }

  getCourtList(venue_id,game){
    var new_selected_one =  Object.assign({}, this.state.rent_details);
    new_selected_one['venue'] = venue_id
    new_selected_one['game_type'] = game
    this.setState({rent_details: new_selected_one});
    const url = `${getLocationOrigin()}/court/getCourt/?venue_id=${venue_id}&game=${game}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ court_list: data.results}))
       .catch(error => error);
  }

  getSearchList(mobile_no) {
    const url = `${getLocationOrigin()}/eagleeye/search/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                         'search': mobile_no
                       });
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({customer_search_list: data.results, search: true}))
       .catch(error => {
         console.log(error);
         alert(error.message);
       });
  }

  blockCourt = ()=> {
    console.log('block')
    console.log(this.state.rent_details.starting_date)
    this.setState({dialog_open_court_list:false})
    if(this.state.available_court_list.length == 0){
      alert("No slots available")
    }
    else{
    var court_bookings = []
    for( var i in this.state.available_court_list)
    {
      court_bookings.push(this.state.available_court_list[i].id)
    }
    this.setState({loading:true})
    const url = `${getLocationOrigin()}/court_booking/advance_block_court/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'court_booking_ids':court_bookings,
                        'reason':this.state.rent_details.reason,
                        'start_time':this.state.rent_details.starting_time,
                        'end_time':this.state.rent_details.ending_time,
                        'start_date':this.state.rent_details.starting_date,
                        'end_date':this.state.rent_details.ending_date,
                        'venue':this.state.rent_details.venue,
                        'courts':this.state.checkedBoxes,
                        'days':this.state.dayscheckedBoxes,
                      });
    console.log('Going to fetch');
    console.log(options['body'])
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) => {                      // first then()
          // alert(response.message);
          console.log(response)
          this.setState({loading:false,failed_list:response.failed_slots,completed_list:response.completed_slots,dialog_open_failed_list:true})
          
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
        this.setState({loading:false,dialog_open_failed_list:true})
      });
    }
  }

  check_availability(data, courts,days,props) {
    if(courts.length === 0){
      alert("select court")
    }
    else if(days.length === 0){
        alert("select day")
    }
    else if(data.starting_date === ''){
        alert("Enter Start Date")
    }
    else if(data.ending_date === ''){
        alert("Enter End Date")
    }
    else if(data.starting_time === ''){
        alert("Enter Start Time")
    }
    else if(data.ending_time === ''){
        alert("Enter End Time")
    }
    else if(data.reason === ''){
      alert("Enter Reason")
    }
  else{
    if(this.state.rent_details.venue === ''){
      var venue = this.state.venue_list[0].id
    }
    else{
      var venue = data.venue
    } 
    this.setState({loading:true})
    var date = moment(data.starting_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
    var ending_date = moment(data.ending_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
    const url = `${getLocationOrigin()}/eagleeye/check_availability_for_bulkbooking/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'venue': venue,
                        'courts':courts,
                        'days':days,
                        'game_type_id': data.game_type,
                        'start_time': data.starting_time,
                        'end_time': data.ending_time,
                        'date': date,
                        'ending_date': ending_date,
                        'reason':data.reason 
                      });
    console.log('Going to fetch');
    console.log(options['body'])
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) => {  
        console.log('response')
        console.log(response)    
        this.setState({loading:false})
        if(!response.success){
              alert(response.message)
        }
        else if(response.available_slot.length > 0 || response.blocked_slot.length > 0 || response.total_slots > 0 || response.previous_bulk_booking ){
              this.setState({dialog_open_court_list:true, available_court_list:response.available_slot, blocked_court_list:response.blocked_slot, total_slots:response.total_slots ,message:response.message,no_of_available_slots:response.available_slot.length,no_of_blocked_slots:response.blocked_slot.length, total_price:response.total_price,advance_amount:response.total_price, net_amount:response.total_price,reamining_amount:0}); 
              // if(response.available_for_bulk && response.available_for_bulk.length > 0){
              //   this.setState({ total_slots:response.total_slots,no_of_available_slots:(response.available_slot.length + response.available_for_bulk.length),message:response.message,available_for_bulk:response.available_for_bulk})
              // } 
              if(response.blocked_for_bulk && response.blocked_for_bulk){
                this.setState({total_slots:response.total_slots ,no_of_available_slots:response.available_slot.length,blocked_for_bulk:response.blocked_for_bulk,message:response.message,no_of_blocked_slots:(response.blocked_slot.length+response.blocked_for_bulk.length)})
              }
              if(response.previous_bulk_booking){
                this.setState({previous_bulk_booking:response.previous_bulk_booking});
              }
            } 
        else{
          alert("No Slot Matched")
        }  
          // alert(response.message);
          // props.history.goBack();
        })
      .catch((error) => {
        console.log(error);
        alert(error.message);
        this.setState({loading:false})
      });
    }
  }

  handleCheckbox = (e, s) => {
    const checkedBoxes = [...this.state.checkedBoxes];
    if(e.target.checked) {
        checkedBoxes.push(s)
    } else {
        const index = checkedBoxes.findIndex((ch) => ch.id === s.id);
        checkedBoxes.splice(index, 1);
    }
    this.setState({checkedBoxes:checkedBoxes});
  }

  handleDaysCheckbox = (e, s) => {
    const dayscheckedBoxes = [...this.state.dayscheckedBoxes];
    if(e.target.checked) {
        dayscheckedBoxes.push(s)
    } else {
        const index = dayscheckedBoxes.findIndex((ch) => ch.id === s.id);
        dayscheckedBoxes.splice(index, 1);
    }
    this.setState({dayscheckedBoxes:dayscheckedBoxes});
    console.log(dayscheckedBoxes)
  }

  handleCustomerSubmit(){
    console.log('post');
      
    const url = `${getLocationOrigin()}/eagleeye/add_new_customer/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'customer_name': this.state.rent_details.cust_name,
                        'customer_mobile': this.state.rent_details.mobile_no,
                      });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .catch(error => {
        console.log(error);
        alert(error.message);
      })
      .then(data => {
        if(data.success){
          var cust = Object.assign([], this.state.rent_details);
          cust.push({'id': data.customer.id, 'name': data.customer.name, 'mobile_no':data.customer.mobile_no});
          this.setState({customer_search_list: cust});
          alert(data.message);
          this.handleClose();
        } else {
          alert(data.message);
        }
       });
  }

  handleChange(event) {
    console.log(event.target.name)
    console.log(event.target.value)
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.rent_details);
    new_selected_one[name] = event.target.value
    console.log(new_selected_one)
    this.setState({rent_details: new_selected_one});
    console.log(this.state)
  }

  handleVenueChange(event){
    const selected_venue_id = event.target.value;
    this.state.game_list = this.state.venue_list.filter(venue => venue.id == selected_venue_id)[0].games
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.rent_details);
    new_selected_one[name] = event.target.value
    new_selected_one['game_type'] = this.state.game_list[0].game_id
    this.setState({rent_details: new_selected_one});
    if(event.target.value != 'true'){
      this.getCourtList(event.target.value,this.state.game_list[0].game_id)
    }
  }

  handleGameChange(event){
    const game = event.target.value;
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.rent_details);
    new_selected_one[name] = event.target.value
    console.log(new_selected_one)
    this.setState({rent_details: new_selected_one});
    if(event.target.value != 'true'){
      this.getCourtList(this.state.rent_details.venue,game)
    }
    console.log(this.state)
  }

  handleOpen = () => {
    this.setState({dialog_open: true, dialog_open_court_list:true,dialog_open_failed_list:true});
  };

  handleClose = () => {
    this.setState({dialog_open: false, dialog_open_court_list:false,dialog_open_failed_list:false,previous_bulk_booking:false});
  };

  check_blocked(data, courts,days,props) {
    if(courts.length === 0){
      alert("select court")
    }
    else if(days.length === 0){
        alert("select day")
    }
    else if(data.starting_date === ''){
        alert("Enter Start Date")
    }
    else if(data.ending_date === ''){
        alert("Enter End Date")
    }
    else if(data.starting_time === ''){
        alert("Enter Start Time")
    }
    else if(data.ending_time === ''){
        alert("Enter End Time")
    }
  else{
    if(this.state.rent_details.venue === ''){
      var venue = this.state.venue_list[0].id
    }
    else{
      var venue = data.venue
    } 
    this.setState({loading:true})
    var date = moment(data.starting_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
    var ending_date = moment(data.ending_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
    const url = `${getLocationOrigin()}/eagleeye/check_availability_for_bulkbooking/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'venue': venue,
                        'courts':courts,
                        'days':days,
                        'game_type_id': data.game_type,
                        'start_time': data.starting_time,
                        'end_time': data.ending_time,
                        'date': date,
                        'ending_date': ending_date,
                        'unblock':true
                      });
    console.log('Going to fetch');
    console.log(options['body'])
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) => {  
        console.log('response')
        console.log(response)    
        this.setState({loading:false})
        if(response.available_slot.length > 0 || response.blocked_slot.length > 0){
            if(response.blocked_slot.length === 0){
              alert("No Blocked Slot found")
            }
            else{
              this.setState({dialog_open_court_list:true, available_court_list:response.available_slot, blocked_court_list:response.blocked_slot})
            }        
        } 
        else{
          alert("No Slot Matched")
        }  
          // alert(response.message);
          // props.history.goBack();
        })
      .catch((error) => {
        console.log(error);
        alert(error.message);
        this.setState({loading:false})
      });
    }
  }

  handleFormSubmit(event) {
    console.log('handleFormSubmit')
    this.handleClose();
    event.preventDefault();
    {this.state.block_state === true ?
      this.check_availability(this.state.rent_details, this.state.checkedBoxes, this.state.dayscheckedBoxes,this.props)
      :
      this.check_blocked(this.state.rent_details, this.state.checkedBoxes, this.state.dayscheckedBoxes,this.props)
    }
    // this.postaddRental(this.state.rent_details, this.props) 
  }

  searchCustomer() {
    {this.state.rent_details.mobile_no?this.getSearchList(this.state.rent_details.mobile_no):
      alert('Search cannot be blank')}
  }

  setSearch(name, customer_id, mobile_no){
    var new_selected_one =  Object.assign({}, this.state.rent_details);
    new_selected_one['customer_id'] = customer_id
    new_selected_one['mobile_no'] = mobile_no
    new_selected_one['name'] = name
    this.setState({rent_details: new_selected_one, search: false});
  }

  handleDate(date){
    // console.log(moment(date).format("YYYY-MM-DD"))
    console.log(date)
    var new_selected_one =  Object.assign({}, this.state.rent_details);
    new_selected_one['date'] = date
    this.setState({rent_details: new_selected_one});
  }

  handleTopButton(){
    console.log('unblock')
    this.setState({block_state: !this.state.block_state})
  }

  unblockCourt = ()=> {
    console.log('block')
    this.setState({dialog_open_court_list:false})
    if(this.state.blocked_court_list.length == 0){
      alert("No slots available")
    }
    else{
    var court_bookings = []
    for( var i in this.state.blocked_court_list)
    {
      court_bookings.push(this.state.blocked_court_list[i].id)
    }
    this.setState({loading:true})
    const url = `${getLocationOrigin()}/court_booking/unblock_court/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'court_booking_ids':court_bookings,
                        'source':'unblock_court'
                      });
    console.log('Going to fetch');
    console.log(options['body'])
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((response) => {                     // first then()
          // alert(response.message);
          console.log(response)
          this.setState({loading:false,failed_list:response.failed_slots,completed_list:response.completed_slots,dialog_open_failed_list:true})
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
        this.setState({loading:false})
      });
    }
  }


  render() {
    console.log('render')
    // console.log(this.state.venue_list[0].games)
    console.log(this.state.game_list)
    console.log(this.state)
    console.log('failed list')
    console.log(this.state.failed_list)
    console.log('completed_list')
    console.log(this.state.completed_list)

    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleClose}
      />,
      <FlatButton
        label={this.state.block_state === true ? "Book" :"Unblock" }
        primary={true}
        onClick={this.state.block_state === true ? this.blockCourt : this.unblockCourt}
      />,
    ];

    const okaction = [
      <FlatButton
        label="OK"
        primary={true}
        onClick={this.handleClose}
      />
    ];


    var days = [{"name":"Monday","id":0},{"name":"Tuesday","id":1},{"name":"Wednesday","id":2},{"name":"Thrusday","id":3},{"name":"Friday","id":4},{"name":"Saturday","id":5},{"name":"Sunday","id":6}]
    return(
      // <div style={styles.container}>
      <div>
        <div className="breadcrumps" style={{marginBottom:'1%'}}>
          <a href={'/#/partnerCourtBooking'}>
            <span>Rental</span>
          </a> 
          <a >
            <span>Block Court</span>
          </a> 
        </div>
        <div className="row" style={{textAlign:'right',marginRight:'2%'}}>
                 <button
                  className="button1"
                    type="button"
                    value="Submit" 
                    onClick={this.handleTopButton} >
                    {this.state.block_state === true ? "Unblock Court" : "Block Court"}
                  </button>
        </div>

        <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12 label_blue_1">
            <h3 style={{textAlign:'center'}}>{this.state.block_state === true ? "Block Court" : "Unblock Court"}</h3>
          </div>
          {this.state.loading === true ?
              <div style={{height:500}}>
                <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}>loading...</div>
              </div>
          :
          <form  className="validated-form form-horizontal" onSubmit={this.handleFormSubmit}>

            {/* <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6"> 
                Customer No
              </div>
              <div className="col-md-6 input-group">
                <input type="text" name="mobile_no" className="form-control"
                  placeholder="Search for.. " value={this.state.rent_details.mobile_no} onChange={this.handleChange}/>
                <span className="input-group-btn">
                  <button className="btn btn-default glyphicon glyphicon-search"
                  type="button" onClick={this.searchCustomer}></button>
                </span>
              </div>
            </div>
            {this.state.search?
              <div className="col-md-12 btn-group">
                {this.state.customer_search_list.length?this.state.customer_search_list.map((x) =>(<button key={x.mobile_no+x.name} className="btn btn-default"
            style={{padding:'1%'}} onClick={() => this.setSearch(x.name,x.id, x.mobile_no)}>{x.name}:{x.mobile_no}</button>))
            :<div className="alert alert-danger" style={{justifyContent: 'space-between', display: 'flex'}}>
            <div className="alert alert-danger">Search customer not found</div>
            <div>
            <RaisedButton
              onClick={this.handleOpen}
              label="Add"
              style={{float:'right'}}
              secondary={true}
            />
            <Dialog
              actions={actions}
              modal={false}
              open={this.state.dialog_open_cust}
              onRequestClose={this.handleClose}
            >
              <div>
                <div style={styles.main_header} className="col-md-12">
                  <h3 style={{textAlign:'center'}}>Add New Customer</h3>
                </div>
                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Name
                  </div>
                  <input type="text" style={styles.input} name="cust_name" className="required"
                    value={this.state.value} onChange={this.handleChange}/>
                </div>

                <div style={styles.items} className="col-md-12">
                  <div style={styles.item_header} className="col-md-6">
                    Mobile No
                  </div>
                  <input type="number" style={styles.input} name="cust_mobile_no" className="required"
                    value={this.state.rent_details.mobile_no} onChange={this.handleChange}/>
                </div>
              </div>
            </Dialog>
          </div>
          </div>
       }</div>:''}  */}

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venue
              </div>
              <select name="venue" className="col-md-6" style={styles.item_body} value={this.state.rent_details.venue}
                onChange={this.handleVenueChange}>
                {/* <option value>-------</option> */}
                {
                  this.state.venue_list.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                }
              </select>
            </div>

            {/* <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Court
              </div>
              <select name="court" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                <option value>-------</option>
                {
                  this.state.court_list.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                }
              </select>
            </div> */}
            
            
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game Type
              </div>
              <select name="game_type" className="col-md-6" style={styles.item_body} value={this.state.rent_details.game_type}
                onChange={this.handleGameChange}>
                {
                  this.state.game_list.map((x, index) => (
                  <option key={x.game_id} value={x.game_id}>{x.game_name}</option>
                  ))
                }
              </select>
            </div>
            {this.state.block_state === true &&
            <div>
            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Reason
              </div>
              <select name="reason" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                <option value>-------</option>
                <option key='0' value='0'>Academy</option>
                <option key='1' value='1'>Improve</option>
                <option key='2' value='2'>Play</option>
                <option key='3' value='3'>Customer</option>
                <option key='4' value='4'>Tournament</option>
                <option key='5' value='5'>Other</option>
              </select>
            </div>
            </div>
              }

            <div style={styles.items} className="col-md-12">
                <div style={styles.court_list}>
                {
                  this.state.court_list.map((x, index) => (
                    <label>
                    <input type="checkbox"
                    checked={this.state.checkedBoxes.find((ch) => ch.id === x.id)}
                    onChange={(e) => this.handleCheckbox(e, x)}
                  />
                  <div key={x.id} value={x.id}>{x.name}</div>
                  </label>
                  ))
                }
                </div>
            </div>


            {/* <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Source
              </div>
              <select name="source" className="col-md-6" style={styles.item_body} value={this.state.value}
                onChange={this.handleChange}>
                <option value>-------</option>
                  <option>Other</option>
                  <option>PLAYO</option>
                  <option>WALK IN</option>
              </select>
            </div> */}

            <div style={{display:'flex', flexDirection: 'row',marginTop:10}} className="col-md-12">
              <div style={{fontSize:'16', color:'red'}}>* Blocking is allowed for maximum 30 days.</div>
            </div>

            <div style={{padding: '1%', display:'flex', flexDirection: 'row'}}>
            <div style={{display:'flex', flexDirection: 'row'}} className="col-md-12">
              <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
                Start Date
              </div>
              <DatePicker selected={this.state.rent_details.starting_date} onChange={this.handleStartDate}/>
            </div>

            <div style={{display:'flex', flexDirection: 'row'}} className="col-md-12">
              <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
                To 
              </div>
              <DatePicker selected={this.state.rent_details.ending_date} onChange={this.handleEndDate}/>
            </div>
            </div>

            <div style={styles.items} className="col-md-12">
            <div style={styles.court_list}>
                {
                  days.map((x, index) => (
                    <label>
                    <input type="checkbox"
                    checked={this.state.dayscheckedBoxes.find((ch) => ch.id === x.id)}
                    onChange={(e) => this.handleDaysCheckbox(e, x)}
                  />
                  <div style={{paddingLeft: '3%', paddingRight:'3%',fontSize:12}} key={x.id} value={x.id}>{x.name}</div>
                  </label>
                  ))
                }
            </div>
            </div>

          {/*<div style={{padding: '1%', display:'flex', flexDirection: 'row', marginBottom:30}}>
            <div style={{display:'flex', flexDirection: 'row'}} className="col-md-12">
              <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
                Start Time(HH:MM:SS)
              </div>
              <TimeField value={this.state.rent_details.starting_time} showSeconds style={styles.input} onChange={this.onStartTimeChange} />
            </div>
            <div style={{display:'flex', flexDirection: 'row'}} className="col-md-12">
              <div style={{fontSize: '100%',fontWeight: 600,paddingLeft: '10%'}} className="col-md-6">
               To 
              </div>
              <TimeField value={this.state.rent_details.ending_time} showSeconds style={styles.input} onChange={this.onEndTimeChange} />
            </div>
          </div>*/}

          <div style={styles.items} className="col-md-12">
                <div style={styles.item_header} className="col-md-6">
                    <span className='col-md-3' style={{display:'contents',marginBottom:'1%'}}>Start Time </span>
                    <div style={{width:'77%'}}>
                        <TimePicker className="col-md-3" style={{width:'50%'}} theme="classic" time={this.state.rent_details.starting_time} name='start_time' onTimeChange={this.onStartTimeChange} />
                    </div>
                </div>
                <div style={styles.item_header} className="col-md-6">
                    <span className='col-md-3' style={{display:'contents',marginBottom:'1%'}}>End Time </span>
                    <div style={{width:'77%'}}>
                        <TimePicker className="col-md-3" style={{width:'50%'}} theme="classic" time={this.state.rent_details.ending_time} name='end_time' onTimeChange={this.onEndTimeChange} />
                    </div>
                </div>
          </div>

            <div style={{display:'flex', flexDirection: 'row',marginTop:10}} className="col-md-12">
              <div style={{fontSize:'16', color:'red'}}>* for 23:00:00 slot enter end time as 23:59:00</div>
            </div>

            {/* <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Start Time(HH:MM:SS)
              </div>
              <input type="text" style={styles.input} className="required" name="start_time" value={this.state.value}
                onChange={this.handleChange} placeholder="19:00:00"/>
            </div> */}

            {/* <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                End Time
              </div>
              <input type="text" style={styles.input} name="end_time" className="required" value={this.state.value}
                onChange={this.handleChange} placeholder="20:00:00"/>
            </div> */}

            {/* <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Amount Collected
              </div>
              <input type="number" style={styles.input} name="amount" className="required"
                value={this.state.value} onChange={this.handleChange}/>
            </div> */}

            <div style={styles.button_submit} className="col-md-12">
              <input className="button1" type="submit" value={this.state.block_state === true ? "Check Slots to Block" : "Check Slots to Un-Block"}/>
                {this.state.previous_bulk_booking.length > 0 ?
                  <div className="col-md-12 label_blue_1" style={{flexDirection:'row',textAlign:'center'}}>
                      <Dialog
                        actions={okaction}
                        modal={false}
                        open={this.state.previous_bulk_booking}
                        onClick={this.handleClose}
                        autoDetectWindowHeight={true}
                        autoScrollBodyContent={true}
                        scroll={scroll}
                        dividers={scroll === 'paper'}
                      >

                      <div style={styles.main_header} className="col-md-12">
                        <h4 style={{textAlign:'center'}}>These slots are not available for bulk booking ,so change date or time and try again </h4>
                      </div>
                      <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                        <div className="col-md-3">
                                Date
                        </div>
                        
                        <div className="col-md-3">
                                Time
                        </div>
                        
                        <div className="col-md-3">
                                Days
                        </div>
                        <div className="col-md-3">
                                Court
                        </div>
                      </div>
                        <div className="col-md-12" style={{flexDirection:'row',textAlign:'center','backgroundColor':"#cfd4d3",'padding':"5px"}}>
                            {this.state.previous_bulk_booking && this.state.previous_bulk_booking.map((Bulk_book,index) =>
                            <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>  
                              <div className="col-md-3">
                                {Bulk_book.start_date} - {Bulk_book.end_date}
                              </div>
                              
                              <div className="col-md-3">
                                {Bulk_book.start_time} - {Bulk_book.end_time}
                              </div>
                              <div className="col-md-3" >
                                {Bulk_book.days}
                              </div>
                              <div className="col-md-3">
                                {Bulk_book.court.map((crt,index) =>
                                  <div><label>{crt.name}
                                  </label></div>
                                  )}
                              </div>
                            </div>
                            )}
                        </div>
                        </Dialog>
                    </div>
                    :
                <Dialog
                    actions={actions}
                    modal={false}
                    open={this.state.dialog_open_court_list}
                    onRequestClose={this.handleClose}
                    scroll={scroll}
                    dividers={scroll === 'paper'}
                  >
              <div>
              {this.state.blocked_court_list.length > 0 &&
                <div style={styles.main_header} className="col-md-12">
                  <h4 style={{textAlign:'center'}}>{this.state.block_state === true ? "Following Slots are not available, press Continue to book the available slots or cancel."
                  :
                  `${this.state.blocked_court_list.length} slots are blocked, press continue to un-block`
                }
                  </h4>
                </div>
              }
              {this.state.block_state === true &&
              <div>
                {this.state.blocked_court_list.length > 0 ?
                <div>
                {this.state.blocked_court_list.map((list,index)=>
                <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                  <div className="col-md-4">
                    {list.court.name}
                  </div>
                  <div className="col-md-4">
                    {list.date}
                  </div>
                  <div className="col-md-4">
                    {list.start_time}
                  </div>
                  </div>
                  )}
                  </div>
                  :
                  <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                    <div>All slots Available!!</div>
                  </div>
                }
                </div>
              }
                </div>
            </Dialog>
          }
            </div>

            <div style={styles.button_submit} className="col-md-12">
              <Dialog
                    actions={okaction}
                    modal={false}
                    open={this.state.dialog_open_failed_list}
                    onRequestClose={this.handleClose}
                    autoDetectWindowHeight={true}
                    autoScrollBodyContent={true}
                  >
              <div>
              {this.state.failed_list && this.state.failed_list.length > 0 ?
                <div style={styles.main_header} className="col-md-12">
                <h4 style={{textAlign:'center'}}> Failed To Book </h4>
                  {this.state.failed_list.map((list,index) =>
                    <div className="col-md-12" style={{flexDirection:'row',textAlign:'center'}}>
                      <div className="col-md-4">
                        {list.name}
                      </div>
                      <div className="col-md-4">
                        {list.date}
                      </div>
                      <div className="col-md-4">
                        {list.time}
                      </div>
                    </div>
                      ) 
                  }
                </div>  
                  :
                  <h4 style={{textAlign:'center'}}>{this.state.block_state === true ?
                    "Blocked Successfully"
                  :
                    "Un-Blocked Successfully"
                  }
                  </h4>
              }
               </div> 
               </Dialog>
            </div>   
                        
            <div className="col-md-12">
              {this.state.data_uploaded?<div className="text-success" style={styles.success}>* Fixture created successfully.</div>:''}
              {this.state.data_error?<div className="text-danger" style={styles.success}>* Error, creation failed.</div>:''}
            </div>
          </form>
          }
          </div>
        </div>
      </div>
    );
  }
}

export default AddRental;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addRental/index.js